import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditOrganisationLayer from "../components/EditIntegrationLayer";

export const EditIntegrationWithIdPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Integration'/>

                {/* Edit Integration */}
                <EditOrganisationLayer/>
            </MasterLayout>
        </>
    )
}